import { render, staticRenderFns } from "./CustomOverlaysStage.vue?vue&type=template&id=5b18d911&"
import script from "./CustomOverlaysStage.vue?vue&type=script&lang=js&"
export * from "./CustomOverlaysStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports